import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ColumnsObject } from '../../../bulk-export-v2/bulk-export-v2.component';
import { MatCheckboxChange } from '@angular/material/checkbox';

interface ExportColumnTemplate {
  templateId: number;
  templateName: string;
  templateList: {
    id: number;
    name: string;
    checked: boolean;
    position: number;
  }[];
}

@Component({
  selector: 'sa-add-edit-export-columns-template',
  templateUrl: './add-edit-export-columns-template.component.html',
  styleUrls: ['./add-edit-export-columns-template.component.scss'],
})
export class AddEditExportColumnsTemplateComponent implements OnInit {
  templateForm: FormGroup;
  selectedData: ExportColumnTemplate;

  constructor(
    private fb: FormBuilder,
    @Inject(MAT_DIALOG_DATA) public data: ExportColumnTemplate,
    private matDialogRef: MatDialogRef<AddEditExportColumnsTemplateComponent>,
  ) {
    this.selectedData = data;
  }

  ngOnInit(): void {
    this.buildForm();
  }

  private buildForm() {
    this.templateForm = this.fb.group({
      templateName: [
        this.selectedData && this.selectedData.templateName ? this.selectedData.templateName : null,
        Validators.required,
      ],
    });
  }

  submitForm() {
    if (this.templateForm.invalid) {
      this.templateForm.markAsTouched();
    } else {
      const visibleColumns = this.selectedData.templateList.filter((column) => column.checked).map((item) => item.name);
      let positionCounter = 1;
      visibleColumns.forEach((item, index) => {
        const match = this.selectedData.templateList.find((c) => c.name === item);
        if (match) {
          match.position = positionCounter++;
        }
      });

      this.selectedData.templateList
        .filter((sd) => !visibleColumns.includes(sd.name))
        .forEach((item) => {
          item.position = positionCounter++;
        });

      this.selectedData.templateList.sort((a, b) => a.position - b.position);

      const columnsToSave = this.selectedData.templateList;

      this.matDialogRef.close({
        data: {
          id: this.selectedData && this.selectedData.templateId ? this.selectedData.templateId : null,
          templateName: this.templateForm.value,
          columns: JSON.stringify(columnsToSave),
        },
        update: !!this.selectedData.templateId,
      });
    }
  }

  closeDialog() {
    this.matDialogRef.close(false);
  }

  onCheckboxChange(col: { id: number; name: string; checked: boolean }, e: MatCheckboxChange) {
    col.checked = e.checked;
  }
}
